<script>
import { manageStoreMethods } from "@state/helpers";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { Sketch } from "vue-color";
export default {
    name: 'CompaniesModal',
    props: {
        activeCompany: {
            type: Object,
            required: false,
            default: () => {}
        },
        companyEdit: {
            type: Object,
            required: false,
            default: () => {}
        },
        callback: {
            type: Function,
            required: false,
            default: () => {}
        },
        closeModal: {
            type: Function,
            required: true
        }
    },
    components: { 
        ValidationProvider, ValidationObserver, 
        "colorPicker": Sketch 
    },
    data() {
        return {
            newCompany: {
                business_name: null,
                nit: null,
                brand: null,
                logo: "653833b5afe78fad649a9a74",
                status: 'active',
                styles: {
                        "primary": "#CCCCCC",
                        "info": "#3C449A", 
                        "error": "#ED627C", 
                        "success": "#43CD87", 
                        "warning": "#EC803F", 
                        "secondary": "#B3B3B3",
                        "auth_mode": "email",
                        "theme": "light"
                    }
            },
            picker: {
                'primary': { visible: false },
                'info': { visible: false },
                'error': { visible: false },
                'success': { visible: false },
                'warning': { visible: false },
                'secondary': { visible: false },
            },
            isSubmitting: false,
            isModalVisible: true,
            assignModalShow: false,
            randomId: Math.random()
        }
    },
    methods: {
        ...manageStoreMethods,
        async submitForm() {
            const isValid = await this.$refs.observer.validate();
            const errors = Object.values(this.$refs.observer.errors).flat();
            if (!isValid) {
                this.$generate_noty('warn', this.$t('forms.form_errors', {'errors':errors.length}), this.$t('alerts.error'),  5000, true)
                return
            }
            this.assignModalShow = true;
        },
        saveCompany(){
            let context = this
            this.isSubmitting = true
            let payload = (
                this.newCompany.business_name &&
                this.newCompany.nit &&
                this.newCompany.brand) ? {
                    business_name: this.newCompany.business_name,
                    brand: this.newCompany.brand,
                    nit: this.newCompany.nit,
                    styles: this.newCompany.styles
                } : null;
            if (!payload){
                const error = "Verifica los datos"
                this.$generate_noty('error', this.$t('forms.create_error'), error, 3000, true);
                this.cancel_or_error(error)
                this.isSubmitting = false
                return
            }
            if (Object.keys(this.companyEdit).length > 0){
                payload._id = this.companyEdit._id
            }
            this.createUpdateCompany((payload)).then(resp => {
                context.isSubmitting = false
                context.callback(resp)
            })
        },
    },
    mounted(){
        if(Object.keys(this.companyEdit).length > 0){
            this.newCompany = this.companyEdit
        }
        
    },
}
</script>



<template>
    <div>
        <b-modal 
            v-model="isModalVisible" size="sm" 
            :title="(Object.keys(companyEdit).length > 0 ? $t('basic.edit') : $t('basic.add')) + ' ' + $tc('fields.company', 1)" 
            @hide="closeModal('cancel')"
            @ok="assignModalShow = true"
            hide-footer
            >
            <ValidationObserver ref="observer" @submit.prevent="submitForm">
                <b-form ref="createform" >
                    <b-row>
                        <b-col md="4">
                            Identificación (NIT):
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="nit"
                                :rules="{'required': true, 'min': 5, 'regex': `^[0-9]+(-[0-9])?$` }">
                                <b-form-input v-model="newCompany.nit" type="text" name="nit" placeholder="Identificación" />
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="8">
                            Razón social:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="name"
                                :rules="{'required': true, 'min': 3 }">
                                <b-form-input v-model="newCompany.business_name" type="text" name="business_name" placeholder="Razón Social"/>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="8">
                            Marca:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="brand"
                                :rules="{'required': true, 'min': 3 }">
                                <b-form-input v-model="newCompany.brand" type="text" name="brand" placeholder="Marca"/>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <div v-for="(property, key) in Object.fromEntries(Object.entries(newCompany.styles).filter(([key]) => Object.keys(picker).includes(key)))" :key="key" class="d-inline-block text-center px-2">
                                <b>{{ key }}</b><br>
                                <div v-if="property.substring(0,1) === '#'" class="d-inline-block">
                                    <a href='#' @click="() => picker[key].visible = !picker[key].visible">
                                        <div class="d-inline-block shadow rounded-sm" :style="`background-color: ${property}; width: 20px; height: 20px`"></div>
                                    </a>
                                    <div style="font-size: 11px" class="py-1">{{ property }}</div>
                                    <div v-if="picker[key].visible" class="mb-2 bg-white" style="position: absolute !important; z-index: 999" >
                                        <b-button @click="() => picker[key].visible = false" size="xs" block><i class="fad fa-close"></i> {{ $t('basic.close') }}</b-button>
                                        <colorPicker  
                                             :value="newCompany.styles[key]" 
                                            @input="(color) => { newCompany.styles[key] = color.hex }" />
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col md="6">
                            <span style="min-width: 140px; display: inline-block">{{ $t('basic.theme') }}:</span>
                            <b-select v-model="newCompany.styles.theme" :options="[{ value: 'light', text: $t('basic.light') },{ value: 'dark', text: $t('basic.dark') }]" size="sm" class="d-inline-block" />
                        </b-col>
                        <b-col md="6">
                            <span style="min-width: 140px; display: inline-block">{{ $t('basic.auth_mode') }}:</span>
                            <b-select v-model="newCompany.styles.auth_mode" :options="[{ value: 'email', text: $t('email') },{ value: 'username', text: $t('username') }]" size="sm" class="d-inline-block" />
                        </b-col>
                    </b-row>
                    <b-card-footer class="bg-transparent p-0 mt-3">
                        <b-button size="sm" variant="secondary" @click="closeModal">
                            {{ $t("basic.cancel") }}
                        </b-button>
                        <b-button type="submit" size="sm" variant="primary" :disabled="isSubmitting" class="ml-1">
                            <span v-if="!isSubmitting">
                                {{ Object.keys(companyEdit).length > 0 ?  $t("basic.edit") : $t("basic.add") }}
                            </span>
                            <b-spinner v-if="isSubmitting" small label="Spinning" variant="light"></b-spinner>
                        </b-button>
                    </b-card-footer>
                </b-form>
            </ValidationObserver>
        </b-modal>
        <b-modal
            id="assign-modal"
            v-model="assignModalShow"
            :title="$t('basic.add')"
            :ok-title="$t('basic.add')"
            ok-variant="primary"
            @hidden="() => assignModalShow = false"
            @ok="saveCompany"
            >
            <p v-if="newCompany && newCompany.business_name">
                <b>Está seguro de agregar esta nueva compañía?</b>
                <br>
                <br>
                Identificación (NIT, CC): <b>{{  newCompany.nit }}</b><br>
                Razón social: <b>{{  newCompany.business_name }}</b><br>
                Marca: <b>{{  newCompany.brand }}</b><br>
            </p>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="secondary" @click="cancel">
                {{ $t("basic.cancel") }}
                </b-button>
                <b-button size="sm" variant="danger" :disabled="isSubmitting" @click="ok">
                <span v-if="!isSubmitting">
                    {{ $t("basic.accept") }}
                </span>
                <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
                </b-spinner>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>